import { Alert as MuiAlert, AlertTitle as MuiAlertTitle } from '@mui/material';
import { IAlertProps } from './Alert.types';

export default function Alert({ children, title, ...props }: IAlertProps) {
  return (
    <MuiAlert {...props}>
      {title && <MuiAlertTitle>{title}</MuiAlertTitle>}
      {children}
    </MuiAlert>
  );
}
